// DashboardStorageMonitor.jsx

import { useState } from "react";
import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";
import ProtectedGrafanaFrame from "./components/ProtectedGrafanaFrame";

const STORAGE_DASHBOARDS = {
  juicefs: {
    label: "JuiceFS (Filesystem)",
    url: "/grafana/d/-hm07csGk/juicefs-dashboard?orgId=1&var-name=efabric-home&kiosk",
  },
  seaweedfs: {
    label: "SeaweedFS (S3 Storage)",
    url: "/grafana/d/nh02dOVnz/seaweedfs?orgId=1&kiosk",
  },
};

const DashboardStorageMonitor = () => {
  const [activeDashboard, setActiveDashboard] = useState("juicefs");
  const grafanaStorageDashboardUrl = STORAGE_DASHBOARDS[activeDashboard].url;

  const handleDashboardChange = (_event, nextDashboard) => {
    if (nextDashboard) {
      setActiveDashboard(nextDashboard);
    }
  };

  return (
    <Box
      sx={{
        height: `calc(100vh - ${60}px)`,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "flex-start", mb: 1 }}>
        <ToggleButtonGroup
          value={activeDashboard}
          exclusive
          onChange={handleDashboardChange}
          size="small"
          aria-label="Storage dashboard selector"
        >
          {Object.entries(STORAGE_DASHBOARDS).map(([dashboard, config]) => (
            <ToggleButton
              key={dashboard}
              value={dashboard}
              sx={{ textTransform: "none" }}
            >
              {config.label}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </Box>
      <ProtectedGrafanaFrame
        src={grafanaStorageDashboardUrl}
        title={`${STORAGE_DASHBOARDS[activeDashboard].label} Dashboard`}
        sx={{
          flex: 1,
          height: "auto",
          minHeight: 0,
        }}
      />
    </Box>
  );
};

export default DashboardStorageMonitor;
